import React from 'react';
import { Spring } from '@/components/ui/Spring';
import styles from './styles.module.scss';

export interface UserWidgetProps {
  name: string;
  role: string;
  avatarUrl?: string;
  coverUrl?: string;
  className?: string;
  children?: React.ReactNode;
}

export const UserWidget: React.FC<UserWidgetProps> = ({
  name,
  role,
  avatarUrl,
  coverUrl,
  className = '',
  children,
}) => {
  const avatarLetter = name.charAt(0).toUpperCase();

  return (
    <Spring className={`card d-flex flex-column ${className}`}>
      {/* Cover - 136px height, uses LazyImage pattern from template */}
      <span className={styles.cover} style={{ display: 'inline-block' }}>
        {coverUrl ? (
          <img src={coverUrl} alt="cover" />
        ) : (
          <span style={{ display: 'inline-block' }}></span>
        )}
      </span>

      {/* Main content - overlaps cover by 40px */}
      <div className={styles.main}>
        {/* Avatar - 80x80 circle, hidden on screens < 360px */}
        <span className={styles.main_avatar}>
          {avatarUrl ? (
            <img src={avatarUrl} alt={name} />
          ) : (
            <span className={styles.avatarLetter}>{avatarLetter}</span>
          )}
        </span>

        {/* User info */}
        <div>
          <h3 className="lh-1">{name}</h3>
          <span className="text-12">{role}</span>
          {children}
        </div>
      </div>
    </Spring>
  );
};

export default UserWidget;
